import * as React from "react";
import { Controller, UseFormReturn } from "react-hook-form";

import { Field, Input } from "@/components/ui";

interface AccountInfoSectionProps {
  form: UseFormReturn<any>;
  isDisabled: boolean;
}

export const AccountInfoSection: React.FC<AccountInfoSectionProps> = ({ form, isDisabled }) => {
  return (
    <div>
      <h4 className="text-xl font-bold text-slate-800 border-b border-slate-100 pb-3 mb-4">Assistant Profile</h4>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column: Personal Name (First & Last) */}
        <div className="flex flex-col gap-5">
          <Controller
            name="firstName"
            control={form.control}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid} error={fieldState.error?.message}>
                <Field.Label>First Name</Field.Label>
                <Input
                  {...field}
                  disabled={isDisabled}
                  placeholder="First Name"
                  data-elm-id="assistantSignUpInputFirstName"
                />
              </Field>
            )}
          />

          <Controller
            name="lastName"
            control={form.control}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid} error={fieldState.error?.message}>
                <Field.Label>Last Name</Field.Label>
                <Input
                  {...field}
                  disabled={isDisabled}
                  placeholder="Last Name"
                  data-elm-id="assistantSignUpInputLastName"
                />
              </Field>
            )}
          />
        </div>

        {/* Right Column: Contact Details (Email) */}
        <div className="flex flex-col justify-start">
          <Controller
            name="email"
            control={form.control}
            render={({ field, fieldState }) => (
              <Field data-invalid={fieldState.invalid} error={fieldState.error?.message}>
                <Field.Label>Email</Field.Label>
                <Input
                  {...field}
                  disabled={isDisabled}
                  type="email"
                  placeholder="Email"
                  data-elm-id="assistantSignUpInputEmail"
                />
              </Field>
            )}
          />
        </div>
      </div>
    </div>
  );
};
